// /home/clement/compta-app/client/src/components/Stocks/Inventaire.js

import React, { useState, useEffect } from "react";
import axios from "axios";

const Inventaire = () => {
    const [stocks, setStocks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStocks = async () => {
            try {
                const response = await axios.get("/api/stocks"); // Assurez-vous que l'URL de l'API est correcte
                setStocks(response.data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchStocks();
    }, []);

    if (loading) return <div>Chargement...</div>;
    if (error) return <div>Erreur: {error}</div>;

    return (
        <div className="inventaire">
            <h2>Inventaire du Stock</h2>
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nom du Produit</th>
                        <th>Quantité</th>
                        <th>Prix Unitaire</th>
                    </tr>
                </thead>
                <tbody>
                    {stocks.map((stock) => (
                        <tr key={stock.id}>
                            <td>{stock.id}</td>
                            <td>{stock.nom}</td>
                            <td>{stock.quantite}</td>
                            <td>{stock.prixUnitaire} EUR</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Inventaire;
